module.exports = __webpack_public_path__ + "static/assets/0354be93075dfe5e3889c3bf25f0bd0a.ttf";